import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from '@cimpress/react-components';

const CrispifyModal = ({ show, onClose, imageUrl, texture, superResolution }) => (
    <Modal
        className='crispify-modal'
        show={show}
        onRequestHide={onClose}
        closeButton={true}
        closeOnOutsideClick={true}
        title='How to use Crispify'
    >
        <div className='crispify-modal__body'>
            <div>To crispify an image, follow these steps.</div>
            <div>
                1) Upload an image to a publicly available url.
                <a href='https://developer.cimpress.io/apis/graphics/uploads-processing-and-storage' target='_blank' rel='noopener noreferrer'> Cimpress Uploads </a>
                is a good place to do this.
            </div>
            <div>
                2) Make an authenticated post using this imageUrl. In Javascript, Axios is a simple library to use for posting to services.
                <pre className='highlight-block'>
                    <code className='json hljs'>
                        {'axios({\n    '}
                        <span className='hljs-attr'>url</span>: <span className='hljs-string'>{"'https://ipa.documents.cimpress.io/v2/process/crispify'"}</span>{',\n    '}
                        <span className='hljs-attr'>method</span>: <span className='hljs-string'>{"'post'"}</span>{',\n    '}
                        <span className='hljs-attr'>data</span>: {'{\n        '}
                        <span className='hljs-attr'>applySuperResolutionToAlpha</span>: <span className='hljs-literal'>{superResolution ? 'true' : 'false'}</span>{',\n        '}
                        <span className='hljs-attr'>textureAmount</span>: <span className='hljs-number'>{texture}</span>{',\n        '}
                        <span className='hljs-attr'>imageUrl</span>: <span className='hljs-string'>{imageUrl
                            || "'https://scenes.documents.cimpress.io/v2/merchants/test-merchant-group1/compositions/1b257140-fe28-4e9e-aa9b-b7114bea9079/assets/e25293be-9948-42fc-a638-c3e9e15e53e5'"
                        }</span>{',\n    '}
                        {'},\n    '}
                        <span className='hljs-attr'>headers</span>: {'{\n        '}
                        <span className='hljs-attr'>Authorization</span>: <span className='hljs-function'>getAuthToken()</span>{',\n        '}
                        <span className='hljs-attr'>{"'Content-Type'"}</span>: <span className='hljs-string'>{"'application/json'"}</span>{',\n    '}
                        {'},\n'}
                        {'})'}
                    </code>
                </pre>
            </div>
            <div>3) Step 2 will return a job ID. Poll the service using this job ID until the service completes.
                <pre className='highlight-block'>
                    <code className='json hljs'>
                        {'axios({\n    '}
                        <span className='hljs-attr'>url</span>: <span className='hljs-string'>{"'https://ipa.documents.cimpress.io/v2/status/JOB_ID_HERE'"}</span>{',\n    '}
                        <span className='hljs-attr'>method</span>: <span className='hljs-string'>{"'get'"}</span>{',\n    '}
                        <span className='hljs-attr'>headers</span>: {'{\n        '}
                        <span className='hljs-attr'>Authorization</span>: <span className='hljs-function'>getAuthToken()</span>{',\n        '}
                        <span className='hljs-attr'>{"'Content-Type'"}</span>: <span className='hljs-string'>{"'application/json'"}</span>{',\n    '}
                        {'},\n'}
                        {'})'}
                    </code>
                </pre>
            </div>
        </div>
    </Modal>
);

export default CrispifyModal;

CrispifyModal.propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    texture: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    imageUrl: PropTypes.string,
    superResolution: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/crispify/crispifyModal.jsx